<template>
  <transition name="fade">
  <div class="question question-boolean question box box-shadow">

    <div class="question--question" v-html="question"></div>

    <div class="answers row answers-boolean">

      <div class="col-4 no-gutters">
        <div class="row">
          <div class="form-radio">
            <input
              type="radio"
              value="true"
              :name="index+'-true'"
              :id="index+'-true'"
              v-model="radioButtonValue"
            />
            <label :for="index+'-true'">Yes</label>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="row">
          <div class="form-radio">
            <input
              type="radio"
              value="false"
              :name="index+'-false'"
              :id="index+'-false'"
              v-model="radioButtonValue"
            />
            <label :for="index+'-false'">No</label>
          </div>
        </div>
      </div>

    </div>

    <footer>Q ID: {{id}} : {{index}}</footer>

  </div>
  </transition>
</template>

<script>
import Question from '@/components/questions/Question'
export default {
  name: 'Boolean',
  extends: Question,
  mounted: function () {
    this.inputVal = this.value
  },
  computed: {
    radioButtonValue: {
      get: function () {
        return this.value
      },
      set: function (e) {
        // Communicate the change to parent component so that selectedValue can be updated
        this.$emit('input', e)
      }
    }
  }
}
</script>

<style scoped lang="scss">

  .answers-boolean {
    /*justify-content:center;*/
    .col {
      flex-grow:0;
    }
  }
</style>
 


// WEBPACK FOOTER //
// src/components/questions/Boolean.vue